// @flow
import * as React from 'react';
import Field from './Field';

const InputField = ({ name }: { name: string }) => (
  <Field
    name={name}
    renderInput={({ value, id, qaId }) => (
      <input
        id={id}
        name={name}
        value={value || ''}
        data-qa-id={qaId}
        hidden
        readOnly
      />
    )}
    hidden
  />
);

export default InputField;
